
import { NuvoTooltip } from '@nuvolo/nuux-core/components/NuvoTooltip';
import type { ClickEvent } from 'devextreme/ui/button';
import React, { useRef } from 'react';
import TMMButton from '../TMMButton';

export type ToolbarButtonType = 'normal' | 'danger';
export interface ToolbarButtonProps {
  icon: string;
  onClick: (e: ClickEvent, ref?: React.RefObject<HTMLDivElement | null>) => void;
  tooltip: string;
  disabled?: boolean;
  showTextOnly?: boolean;
  filled?: boolean;
  type?: ToolbarButtonType;
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  icon,
  onClick,
  tooltip,
  disabled,
  showTextOnly,
  filled,
  type = 'normal',
}) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  return (
    <NuvoTooltip content={tooltip}>
      <div ref={buttonRef}>
        {showTextOnly ? (
          <TMMButton
            className={`nuvo-grid-toolbar-btn${type === 'danger' ? ' nuvo-toolbar-button-danger' : ''}`}
            onClick={(e) => onClick(e, buttonRef)}
            label={tooltip}
            type="secondary"
            disabled={disabled}
          />
        ) : (
          <TMMButton
            className={`nuvo-grid-toolbar-btn${type === 'danger' ? ' nuvo-toolbar-button-danger' : ''}`}
            icon={icon}
            onClick={(e) => onClick(e, buttonRef)}
            type="secondary"
            disabled={disabled}
          />
        )}
      </div>
    </NuvoTooltip>
  );
};

export default React.memo(ToolbarButton);
